import { memo, useCallback, useState } from 'react';
import { IconAlert, IconSended } from '@app/icons';
import { Button } from 'components/ui/button';
import Loader from 'components/Loader';
import { Modal, ModalProps } from '@app/components';

interface Props extends Partial<ModalProps> {
  textSuccess?: string;
  onAccept: () => void;
  textButtonSuccess?: string;
  textButtonCancel?: string;
  skipSuccessStep?: boolean;
  subText?: string;
}

function ConfirmModal(props: Props) {
  const {
    title,
    textSuccess = '',
    onAccept,
    visible,
    onClose,
    textButtonSuccess = 'Да',
    textButtonCancel = 'Нет',
    skipSuccessStep = false,
    subText,
  } = props;
  const [messageSent, onSendMessage] = useState(false);
  const [isPending, setIsPending] = useState(false);

  const onAcceptHandler = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await onAccept();
      setIsPending(true);
      setTimeout(() => {
        setIsPending(false);
      }, 1500);
      onSendMessage(true);
    } catch (error) {}
  };

  const onCloseModal = useCallback(() => {
    onSendMessage(false);
    if (!!onClose) {
      onClose();
    }
  }, [onClose]);

  if (!visible) {
    return null;
  }

  return (
    <Modal title={''} visible={visible} onClose={onCloseModal} size="medium">
      <div className="flex flex-col items-center justify-center p-6 gap-6">
        {!skipSuccessStep && messageSent ? (
          <>
            {isPending ? (
              <span className="flex items-center justify-center h-24">
                <Loader />
              </span>
            ) : (
              <>
                <span className="mb-4 flex items-center justify-center">
                  <IconSended />
                </span>
                <div className="text-lg font-semibold mb-2 text-center">
                  {textSuccess}
                </div>
                <div className="flex justify-center">
                  <Button onClick={onClose}>Понятно</Button>
                </div>
              </>
            )}
          </>
        ) : (
          <>
            <span className="mb-4 flex items-center justify-center">
              <IconAlert />
            </span>
            <div className="text-lg font-semibold mb-2 text-center">
              {title}
            </div>
            {subText && (
              <div className="text-sm text-muted-foreground mb-2 text-center">
                {subText}
              </div>
            )}
            <div className="flex justify-center gap-4 mt-4">
              <Button variant="outline" onClick={onCloseModal}>
                {textButtonCancel}
              </Button>
              <Button onClick={onAcceptHandler}>{textButtonSuccess}</Button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}

export default memo(ConfirmModal);
